
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3KGVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d18ebc68320409fe$export$2e2bcd8739ae039);

var $2jDha = parcelRequire("2jDha");

var $axKFq = parcelRequire("axKFq");

var $1RFT0 = parcelRequire("1RFT0");

var $knPb9 = parcelRequire("knPb9");

var $2hox0 = parcelRequire("2hox0");

var $lbttE = parcelRequire("lbttE");

var $fz8wa = parcelRequire("fz8wa");

var $WE1Mo = parcelRequire("WE1Mo");

var $1uW3Y = parcelRequire("1uW3Y");

var $e4aUt = parcelRequire("e4aUt");
var /* Using withAnalyticsEvents HOC instead of ComponentWithAnalytics so we can fire on the
 * navigation channel and add actionSubjectId and attributes easily.
 * The withAnalyticsEvents HOC must wrap keyboardShortcuts first so it does not override any injected
 * props. */ $d18ebc68320409fe$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $2jDha.default)({
    showSearch: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'quickSearch',
            key: '/'
        }),
    showIssueCreate: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'createIssue',
            key: 'c'
        }),
    navigateToIssueSearch: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'findIssues',
            key: 'g i'
        }),
    navigateToMostRecentProject: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'browseToProject',
            key: 'g p'
        })
})((0, $e4aUt.default)), {
    navigateToIssueSearch: $WE1Mo.navigateToIssueSearch,
    navigateToMostRecentProject: $WE1Mo.navigateToMostRecentProject,
    ApplicationPermissionsSubscriber: $fz8wa.ApplicationPermissionsSubscriber,
    KeyboardShortcutsDialog: $1uW3Y.KeyboardShortcutsDialog,
    ProjectCreateDrawerConsumer: $lbttE.ProjectCreateDrawerConsumer,
    Shortcuts: $axKFq.CommandShortcuts,
    NavUIControllerSubscriber: $2hox0.UIControllerSubscriber
});

});
parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $6jiFZ = parcelRequire("6jiFZ");

var $fmmnJ = parcelRequire("fmmnJ");
var $awzwr = parcelRequire("awzwr");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});






parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("1RFT0", function(module, exports) {

$parcel$export(module.exports, "keyboardShortcutPressed", () => $07ce1d1304b9ed6e$export$32c6c6b79f098d3);
$parcel$export(module.exports, "productNavigationExpandedCollapsed", () => $07ce1d1304b9ed6e$export$e2ad10d5be2f2400);
/**
 * This file contains analytics functions related to navigation keyboard shortcuts.
 * We are firing events on the navigation fabric channel to align with the other events
 * specified in https://hello.atlassian.net/wiki/spaces/PData/pages/140331306/Minimum+Event+Spec+-+Navigation
 * These functions are used in both nav v1 and nav v2 at the moment with a long term goal of moving global navigation
 * keyboard shortcuts within atlaskit itself.
 */ 
var $6PJBT = parcelRequire("6PJBT");
const $07ce1d1304b9ed6e$export$32c6c6b79f098d3 = ({ createAnalyticsEvent: createAnalyticsEvent, id: id, key: key, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut',
        actionSubjectId: id,
        attributes: {
            navVersion: window.__NAV_VERSION__ || 'UNKNOWN',
            key: key,
            ...attributes
        }
    }).fire((0, $6PJBT.FabricChannel).navigation);
};
const $07ce1d1304b9ed6e$export$e2ad10d5be2f2400 = ({ createAnalyticsEvent: createAnalyticsEvent, isCollapsed: isCollapsed })=>{
    createAnalyticsEvent({
        action: isCollapsed ? 'expanded' : 'collapsed',
        actionSubject: 'productNavigation',
        attributes: {
            trigger: 'keyboardShortcut'
        }
    }).fire((0, $6PJBT.FabricChannel).navigation);
};

});

parcelRegister("2hox0", function(module, exports) {

$parcel$export(module.exports, "UIControllerSubscriber", () => $b52525162b6724ab$export$8e3db525e646de2c);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $b52525162b6724ab$export$8e3db525e646de2c = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $kpmC0.useLeftSidebarState)();
    const stateRef = (0, $eUqFw.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $eUqFw.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};

});

parcelRegister("WE1Mo", function(module, exports) {

$parcel$export(module.exports, "ISSUE_SEARCH_PATH", () => $910dc98c07492a35$export$160e2509706f1f3d);
$parcel$export(module.exports, "navigateToIssueSearch", () => $910dc98c07492a35$export$722548870edd83a4);
$parcel$export(module.exports, "navigateToMostRecentProject", () => $910dc98c07492a35$export$6e7d070c02020dbd);

var $lRmyA = parcelRequire("lRmyA");
const $910dc98c07492a35$export$160e2509706f1f3d = '/issues/';
const $910dc98c07492a35$export$722548870edd83a4 = ()=>window.open($910dc98c07492a35$export$160e2509706f1f3d, '_self');
const $910dc98c07492a35$export$6e7d070c02020dbd = ()=>(0, $lRmyA.performGetRequest)('/rest/internal/2/productsearch/search?type=projects').then((data)=>{
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        const section = data.find(({ id: id })=>id === 'quick-search-projects');
        if (section && section.items && section.items[0] && section.items[0].url) window.open(section.items[0].url, '_self');
    });

});

parcelRegister("1uW3Y", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutsDialog", () => $25bf49bbb8999b18$export$dc5d1c021e0a8741);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25bf49bbb8999b18$var$KeyboardShortcutsDialogLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("1S6lm")), {
    ssr: false,
    moduleId: "./src/packages/common/components/keyboard-shortcuts-dialog/src/index.tsx"
});
const $25bf49bbb8999b18$export$dc5d1c021e0a8741 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts-dialog",
        packageName: "jira-keyboard-shortcuts",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "keyboard-shortcuts.dialog",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25bf49bbb8999b18$var$KeyboardShortcutsDialogLazy, props)));

});
parcelRegister("1S6lm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('vZJTw');
        const value = parcelRequire('5PkhS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("vZJTw").then(()=>parcelRequire('5PkhS'));
}

});


parcelRegister("e4aUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $df34b0e486ddc802$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $cSu9v = parcelRequire("cSu9v");

var $f4oGi = parcelRequire("f4oGi");

var $eQuyQ = parcelRequire("eQuyQ");

var $9zALC = parcelRequire("9zALC");
var $jmejm = parcelRequire("jmejm");
var $gfXKy = parcelRequire("gfXKy");
var $gIIkx = parcelRequire("gIIkx");

var $1RFT0 = parcelRequire("1RFT0");

var $f2Poq = parcelRequire("f2Poq");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kAiYS = parcelRequire("kAiYS");

var $SEaoU = parcelRequire("SEaoU");

var $WE1Mo = parcelRequire("WE1Mo");


var $iUV1N = parcelRequire("iUV1N");

var $56eCS = parcelRequire("56eCS");
// eslint-disable-next-line jira/react/no-class-components
class $df34b0e486ddc802$var$KeyboardShortcuts extends (0, $eUqFw.Component) {
    getKeyMap({ toggleHelpPanel: toggleHelpPanel, openKeyboardShortcutsDialog: openKeyboardShortcutsDialog, toggleCollapse: toggleCollapse, isNextGen: isNextGen }) {
        const { navigateToIssueSearch: navigateToIssueSearch, navigateToMostRecentProject: navigateToMostRecentProject, showIssueCreate: showIssueCreate, showSearch: showSearch, shouldUseHelpShortcut: shouldUseHelpShortcut, formatMessage: formatMessage, getKeywords: getKeywords } = this.props;
        const keys = isNextGen === true ? {
            '?': {
                callback: openKeyboardShortcutsDialog,
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
                                label: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$e0515b3bb1ce3f33)
                    }
                }
            },
            '/': {
                callback: showSearch
            },
            '[': {
                callback: toggleCollapse
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{}
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject()
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $iUV1N.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                    label: formatMessage((0, $iUV1N.default).viewAllIssues)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $WE1Mo.ISSUE_SEARCH_PATH),
                    path: (0, $WE1Mo.ISSUE_SEARCH_PATH)
                })
            },
            c: {
                callback: showIssueCreate,
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                                label: formatMessage((0, $iUV1N.default).createIssue)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$4e353cf4f7beb2cd)
                    }
                }
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    registerInCommandPalette: {
                        name: formatMessage((0, $iUV1N.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQuyQ))), {
                                    label: formatMessage((0, $iUV1N.default).getHelp)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$42dbd0c9d165bb55)
                        }
                    }
                }
            } : null
        } : {
            '/': {
                callback: showSearch,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).quickSearch)
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).closeDrawer)
            },
            c: {
                callback: showIssueCreate,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).createIssue),
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                                label: formatMessage((0, $iUV1N.default).createIssue)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$4e353cf4f7beb2cd)
                    }
                }
            },
            '?': {
                callback: openKeyboardShortcutsDialog,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).keyboardShortcuts),
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
                                label: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$e0515b3bb1ce3f33)
                    }
                }
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).findIssues),
                registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $iUV1N.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                    label: formatMessage((0, $iUV1N.default).viewAllIssues)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $WE1Mo.ISSUE_SEARCH_PATH),
                    path: (0, $WE1Mo.ISSUE_SEARCH_PATH)
                })
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).browseAProject)
            },
            '[': {
                callback: toggleCollapse,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).toggleSidebar)
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).openHelpPanel),
                    registerInCommandPalette: {
                        name: formatMessage((0, $iUV1N.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQuyQ))), {
                                    label: formatMessage((0, $iUV1N.default).getHelp)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$42dbd0c9d165bb55)
                        }
                    }
                }
            } : null,
            [`${(0, $56eCS.getShortcutModifierKey)()}+k`]: {
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).openCommandPalette),
                priority: -1 // this keyboard shortcut is only registered here to show up in the helper dialog. Its registration is in @atlassian/jira-command-palette-integration
            }
        };
        return keys;
    }
    createToggleCollapse(navAPI) {
        return ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
            const contextualNavigation = document.querySelector('[data-testid="ContextualNavigation"]');
            // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
            const isVisible = contextualNavigation && contextualNavigation.style.width !== '0px';
            if (isVisible === true) {
                (0, $1RFT0.keyboardShortcutPressed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    id: 'expandCollapseSidebar',
                    key: '['
                });
                (0, $1RFT0.productNavigationExpandedCollapsed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    isCollapsed: isCollapsed
                });
                toggleCollapse();
            }
        };
    }
    createToggleHelpPanel(isNextGen) {
        return ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, toggleHelpPanel: toggleHelpPanel } = this.props;
            (0, $1RFT0.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'openHelpPanel',
                key: 'h',
                attributes: {
                    helpPanelVersion: (0, $f2Poq.HELP_PANEL_VERSION),
                    helpPanelType: 'inProductHelp',
                    nextGenProject: isNextGen
                }
            });
            toggleHelpPanel();
        };
    }
    createOpenKeyboardShortcutsDialog(openDialog) {
        return ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            (0, $1RFT0.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'keyboardShortcuts',
                key: '?'
            });
            openDialog();
        };
    }
    render() {
        const { ApplicationPermissionsSubscriber: ApplicationPermissionsSubscriber, KeyboardShortcutsDialog: KeyboardShortcutsDialog, ProjectCreateDrawerConsumer: ProjectCreateDrawerConsumer, Shortcuts: Shortcuts, NavUIControllerSubscriber: NavUIControllerSubscriber } = this.props;
        return(// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApplicationPermissionsSubscriber, null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectCreateDrawerConsumer, null, ({ data: { isOpen: isOpen } })=>isOpen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAiYS.ModalsContainer), {
                    scope: "keyboard-shortcuts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAiYS.ModalsSubscriber), null, (isKeyboardShortcutsDialogOpen, { open: open, close: close })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: contextData })=>{
                        const isNextGen = contextData && contextData.contextType === 'project' ? contextData.project.isSimplified : false;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isKeyboardShortcutsDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(KeyboardShortcutsDialog, {
                            isOpen: true,
                            onDialogDismissed: close,
                            applicationPermissionData: data.applicationPermissions,
                            isNextGen: isNextGen,
                            shouldUseHelpShortcut: true
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NavUIControllerSubscriber, null, (navAPI)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Shortcuts, {
                                isSpa: __SPA__,
                                label: isNextGen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).globalShortcuts),
                                keyMap: this.getKeyMap({
                                    toggleHelpPanel: this.createToggleHelpPanel(isNextGen),
                                    openKeyboardShortcutsDialog: this.createOpenKeyboardShortcutsDialog(open),
                                    toggleCollapse: this.createToggleCollapse(navAPI),
                                    isNextGen: isNextGen
                                })
                            })));
                    }))))));
    }
}
const $df34b0e486ddc802$export$89fa8f7790ea1f0e = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hideAndTransformNavigationCommand: hideAndTransformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df34b0e486ddc802$var$KeyboardShortcuts, {
        formatMessage: formatMessage,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        getKeywords: getKeywords,
        ...props
    });
};
var $df34b0e486ddc802$export$2e2bcd8739ae039 = $df34b0e486ddc802$export$89fa8f7790ea1f0e;

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = $c3c90a7e02e55e7e$var$AddIcon;
module.exports.default = $c3c90a7e02e55e7e$var$_default;

});

parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.793 5.793a.999.999 0 000 1.414L15.586 11H6a1 1 0 000 2h9.586l-3.793 3.793a.999.999 0 000 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 00.293-.679v-.057a.996.996 0 00-.293-.678l-5.499-5.5a1 1 0 00-1.415 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = $9601eacac1d33448$var$ArrowRightIcon;
module.exports.default = $9601eacac1d33448$var$_default;

});

parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $af8a5fe38412111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5.836 6.95l-3.825 9.97a.5.5 0 00.467.68h1.208a.5.5 0 00.47-.33l.683-1.877a.5.5 0 01.47-.33H9.12a.5.5 0 01.47.33l.683 1.878a.5.5 0 00.47.329h1.272a.5.5 0 00.468-.678L8.685 6.95a.7.7 0 00-.655-.45H6.49a.7.7 0 00-.654.45zm1.566 2.457l1.25 3.414a.2.2 0 01-.188.269H5.966a.2.2 0 01-.188-.269l1.249-3.414a.2.2 0 01.375 0zm10.148 6.465c1.222 0 2.142-1.01 2.142-2.603 0-1.594-.902-2.532-2.142-2.532-1.256 0-2.178.938-2.178 2.532 0 1.575.904 2.603 2.178 2.603zm2.161.602c-.372.833-1.276 1.433-2.445 1.433-2.567 0-4.266-2-4.266-4.638 0-2.551 1.664-4.569 4.195-4.569 1.56 0 2.284.833 2.497 1.329v-.34c0-.247.007-.392.213-.576.137-.122.344-.177.62-.165h.764a.581.581 0 01.496.165c.213.203.192.421.192.577v6.394c0 .227.008.526.023.899 0 .191-.041.336-.124.434a.628.628 0 01-.508.242h-.93c-.193 0-.45-.084-.533-.184-.083-.1-.165-.23-.183-.532a6.342 6.342 0 01-.01-.364v-.105z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = $af8a5fe38412111b$var$EmojiKeyboardIcon;
module.exports.default = $af8a5fe38412111b$var$_default;

});

parcelRegister("eQuyQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aceda0cfde73f17b$var$_react = $aceda0cfde73f17b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aceda0cfde73f17b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aceda0cfde73f17b$var$QuestionIcon = (props)=>/*#__PURE__*/ $aceda0cfde73f17b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18a1 1 0 010-2 1 1 0 010 2m-2-9a1 1 0 11-2 0 1 1 0 012 0"/><path d="M15.89 8.048a3.971 3.971 0 00-2.951-2.94A4.005 4.005 0 008 9.087a.073.073 0 00.009.008l1.878.022.112-.116A2.002 2.002 0 0112 7c1.103 0 2 .897 2 2 0 1.102-.897 2-2 2h.008a1 1 0 00-.998.987v2.014a1 1 0 102 0v-.782c0-.217.145-.399.349-.472a3.991 3.991 0 002.53-4.699"/></g></svg>`
    }, props));
$aceda0cfde73f17b$var$QuestionIcon.displayName = 'QuestionIcon';
var $aceda0cfde73f17b$var$_default = $aceda0cfde73f17b$var$QuestionIcon;
module.exports.default = $aceda0cfde73f17b$var$_default;

});

parcelRegister("gIIkx", function(module, exports) {

$parcel$export(module.exports, "useTransformNavigationCommands", () => $2a846d5538aecfbb$export$5b108cd54c923a60);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $23NQ5 = parcelRequire("23NQ5");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $8FbYY = parcelRequire("8FbYY");
var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");

var $8A5Pc = parcelRequire("8A5Pc");

var $4HIA6 = parcelRequire("4HIA6");

var $1Uuz9 = parcelRequire("1Uuz9");

var $duyJV = parcelRequire("duyJV");

const $2a846d5538aecfbb$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $kJlBc.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $gCtL7.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openNewTab = (0, $eUqFw.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $eUqFw.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $eUqFw.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $8FbYY.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            if ((0, $1ybV0.ff)('compal-task-success-event')) (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HIA6.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $eUqFw.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.IconContainer), {
                        "data-testid": (0, $f3c17e0f83ec4de3$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                        label: ""
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $1Uuz9.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $eUqFw.useCallback)((hideCommandPath)=>!(0, $duyJV.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $eUqFw.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $eUqFw.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};

});
parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: (0, $eUqFw.Fragment),
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            group: result.group,
            key: index
        }, (0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainer, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainerOld, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), (0, $bKxX9.ff)('compal-issue-actions') ? renderAfterCommands?.({}) : !loadingList && renderAfterCommands && renderAfterCommands({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1oud _k48p1nn1 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        role: "listbox",
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        ref: ref,
        "aria-label": (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel) : undefined,
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "separator"
        }))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $PdmhA).N400})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, containerRef: containerRef, shouldShowTooltip: shouldShowTooltip })=>{
    let shouldShowTruncatedTooltip = false;
    if (!(0, $1ybV0.ff)('compal-update-active-tooltip')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: (0, $1ybV0.ff)('compal-update-active-tooltip') ? !!shouldShowTooltip : shouldShowTruncatedTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
};
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld = ({ children: children, isActive: isActive })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
        ref: containerRef
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        containerRef: containerRef
    }, children));
};
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$export$4495aca3d261add0 = (0, $bAQOb.componentWithFF)('compal-update-active-tooltip', $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew, $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld);
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("8A5Pc", function(module, exports) {

$parcel$export(module.exports, "NameContainer", () => $1a80cd2471468c76$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $1a80cd2471468c76$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1a80cd2471468c76$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $1a80cd2471468c76$export$8f314e512d92575f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4HIA6", function(module, exports) {

$parcel$export(module.exports, "NavigationLink", () => $0497a7ba6bc39231$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kJlBc = parcelRequire("kJlBc");
const $0497a7ba6bc39231$export$721ee963a67379f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Uuz9", function(module, exports) {

$parcel$export(module.exports, "NewTabHintMessage", () => $16f6fd73a925a670$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $LddR2 = parcelRequire("LddR2");
var $5t8Df = parcelRequire("5t8Df");

var $igOBb = parcelRequire("igOBb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1TF2x = parcelRequire("1TF2x");
const $16f6fd73a925a670$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$FooterContentContainer, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$DefaultFooterContainer, null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MessageWrapper, null, formatMessage((0, $1TF2x.messages).openInANewTab)), (0, $igOBb.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacTextOffset, null, "\u2318")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterIconSVG, null)))));
};
const $16f6fd73a925a670$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: `var(--ds-text-subtle, ${(0, $PdmhA).N600})`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$FooterContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$DefaultFooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$HintMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syazc8hx _u5f312x7",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _k48p1nn1 _1wybf6fq _vwz47vkz _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacTextOffset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$WindowsLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1qjk _k48p1nn1 _1p1d1dk0 _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$EnterLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1TF2x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62b2c63e3a44a01a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $62b2c63e3a44a01a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("duyJV", function(module, exports) {

$parcel$export(module.exports, "isCurrentPage", () => $fc96c12861a877b0$export$d4781f4a7d66b55c);
const $fc96c12861a877b0$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $f3c17e0f83ec4de3$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';


parcelRegister("kAiYS", function(module, exports) {

$parcel$export(module.exports, "ModalsContainer", () => $82008c78277b9b5a$export$5dffa5a5319be22d);
$parcel$export(module.exports, "ModalsSubscriber", () => $82008c78277b9b5a$export$facc296933ebcadf);

var $heB5U = parcelRequire("heB5U");
var $dYfll = parcelRequire("dYfll");

var $eMGrB = parcelRequire("eMGrB");
const $82008c78277b9b5a$export$5dffa5a5319be22d = (0, $heB5U.createContainer)((0, $eMGrB.default));
const $82008c78277b9b5a$export$facc296933ebcadf = (0, $dYfll.createSubscriber)((0, $eMGrB.default), {
    displayName: 'ModalsSubscriber',
    selector: (state)=>state.isOpen
});

});
parcelRegister("eMGrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $70da9ac93f6b241a$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $fjynS = parcelRequire("fjynS");
const $70da9ac93f6b241a$var$initialState = {
    isOpen: false
};
var $70da9ac93f6b241a$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'modals',
    initialState: $70da9ac93f6b241a$var$initialState,
    actions: $fjynS.default
});

});
parcelRegister("fjynS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d52ffb5755573be$export$2e2bcd8739ae039);
const $4d52ffb5755573be$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
var $4d52ffb5755573be$export$2e2bcd8739ae039 = $4d52ffb5755573be$var$actions;

});



const $43e5db31f2699c3a$export$e0515b3bb1ce3f33 = 'viewKeyboardShortcuts';
const $43e5db31f2699c3a$export$5f007fc3736b8e2b = 'viewAllIssues';
const $43e5db31f2699c3a$export$4e353cf4f7beb2cd = 'createIssue';
const $43e5db31f2699c3a$export$42dbd0c9d165bb55 = 'getHelp';

parcelRegister("iUV1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed06c35ec0ee63b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ed06c35ec0ee63b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalShortcuts: {
        "id": "keyboard-shortcuts.global-shortcuts",
        "defaultMessage": "Global shortcuts"
    },
    quickSearch: {
        "id": "keyboard-shortcuts.quick-search",
        "defaultMessage": "Quick search"
    },
    closeDrawer: {
        "id": "keyboard-shortcuts.close-drawer",
        "defaultMessage": "Close drawer"
    },
    createIssue: {
        "id": "keyboard-shortcuts.create-issue",
        "defaultMessage": "Create issue"
    },
    keyboardShortcuts: {
        "id": "keyboard-shortcuts.keyboard-shortcuts",
        "defaultMessage": "Keyboard shortcuts"
    },
    keyboardShortcutsCommandPalette: {
        "id": "keyboard-shortcuts.keyboard-shortcuts-command-palette",
        "defaultMessage": "View keyboard shortcuts"
    },
    findIssues: {
        "id": "keyboard-shortcuts.find-issues",
        "defaultMessage": "Find issues"
    },
    browseAProject: {
        "id": "keyboard-shortcuts.browse-a-project",
        "defaultMessage": "Browse to a project"
    },
    toggleSidebar: {
        "id": "keyboard-shortcuts.toggle-sidebar",
        "defaultMessage": "Toggle sidebar"
    },
    openHelpPanel: {
        "id": "keyboard-shortcuts.open-help-panel",
        "defaultMessage": "Open help panel"
    },
    openCommandPalette: {
        "id": "keyboard-shortcuts.open-command-palette",
        "defaultMessage": "Open command palette"
    },
    quickSearchCommand: {
        "id": "keyboard-shortcuts.quick-search-command",
        "defaultMessage": "Open quick search"
    },
    getHelp: {
        "id": "keyboard-shortcuts.get-help",
        "defaultMessage": "Get help"
    },
    viewAllIssues: {
        "id": "keyboard-shortcuts.view-all-issues",
        "defaultMessage": "View all issues"
    }
});

});

parcelRegister("56eCS", function(module, exports) {

$parcel$export(module.exports, "getShortcutModifierKey", () => $0076e2fabf35be6f$export$fe66dae91c68619b);
const $0076e2fabf35be6f$var$isMacOs = ()=>/Mac/i.test(window?.navigator?.platform);
const $0076e2fabf35be6f$export$fe66dae91c68619b = ()=>$0076e2fabf35be6f$var$isMacOs() ? 'meta' : 'ctrl';

});




//# sourceMappingURL=async-keyboard-shortcuts-mapping.e0071d67.js.map
